import { useMutation, useQueryClient } from "@tanstack/react-query";
import addTeam from "../helpers/addTeam";
import { NewTeamDataType } from "../types/TeamMutationTypes";
import updateTeam from "../helpers/updateTeam";
import deleteTeam from "../helpers/deleteTeam";
import { updateUser } from "@coworker/app/src/services/user.service";

export const useCreateTeam = (storeId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newTeamData: NewTeamDataType) => addTeam(newTeamData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["storeTeamsWithUsersCount", storeId],
        refetchType: "all",
      });
      queryClient.invalidateQueries({
        queryKey: ["storeTeams", storeId],
        refetchType: "all",
      });
    },
  });
};

export const useUpdateTeam = (storeId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updatedTeamData: NewTeamDataType) =>
      updateTeam(updatedTeamData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["storeTeamsWithUsersCount", storeId],
        refetchType: "all",
      });
      queryClient.invalidateQueries({
        queryKey: ["storeTeams", storeId],
        refetchType: "all",
      });
    },
  });
};

export const useDeleteTeam = (storeId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (teamId: string) => deleteTeam(teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["storeTeamsWithUsersCount", storeId],
        refetchType: "all",
      });
      queryClient.invalidateQueries({
        queryKey: ["storeTeams", storeId],
        refetchType: "all",
      });
    },
  });
};

export const useAddUserToTeam = (storeId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ fixaUid, teamId }: { fixaUid: string; teamId: string }) =>
      updateUser(fixaUid, { team_id: teamId }),
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ["store", "users"],
      });
      queryClient.invalidateQueries({
        queryKey: ["storeTeams", storeId],
        refetchType: "all",
      });
      queryClient.invalidateQueries({
        queryKey: ["storeTeamsWithUsersCount", storeId],
        refetchType: "all",
      });
    },
  });
};
